module.exports = __webpack_public_path__ + "img/Delivery2.83686cd3.svg";